import { useDemoAccess } from "./demo-access-context";

export default function DemoTryButton({ label, demoUrl, demoName }) {
  const { openDemo } = useDemoAccess();

  return (
    <button
      type="button"
      onClick={() => openDemo(demoUrl, demoName)}
      className="use-case-try-btn group inline-flex items-center justify-center gap-2 w-full lg:w-auto shrink-0 self-start lg:self-center px-6 py-3 rounded-[6px] bg-teal text-white font-semibold text-[15px] transition-all duration-200 hover:bg-[#11997A] hover:scale-[1.03] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal"
    >
      {label}
      <span
        className="inline-block transition-transform duration-200 ease-out group-hover:translate-x-1"
        aria-hidden
      >
        →
      </span>
    </button>
  );
}
